import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Button } from "../ui";

const ConfirmModal = ({ show, onHide, title, message, action, actionData, visibility }) => {
  const { t, i18n } = useTranslation("translation");

  const isArabic = i18n.language === "ar";
  const textDir = i18n.dir();

  const confirmButton = (
    <Button
      color="danger"
      className={isArabic ? "me-2" : ""}
      onClick={() => {
        action(actionData, visibility);
        onHide();
      }}
    >
      {t("confirm")}
    </Button>
  );

  const cancelButton = (
    <Button
      color="secondary"
      className={isArabic ? "" : "me-2"}
      onClick={onHide}
    >
      {t("cancel")}
    </Button>
  );

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        centered
        backdropClassName="confirm-modal-backdrop"
        style={{ zIndex: 1060 }}
      >
        <Modal.Header closeButton>
          <Modal.Title dir={textDir}>{title || `${t("confirmaction")}`}</Modal.Title>
        </Modal.Header>
        <Modal.Body dir={textDir} lang={i18n.language}>
          {message || `${t("areyousureyouwanttoproceed")}`}
        </Modal.Body>

        <Modal.Footer className="justify-content-end">
          {isArabic ? (
            <>
              {confirmButton}
              {cancelButton}
            </>
          ) : (
            <>
              {cancelButton}
              {confirmButton}
            </>
          )}
        </Modal.Footer>
      </Modal>

      <style>{`
        .confirm-modal-backdrop {
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          background-color: rgba(0, 0, 0, 0.6) !important;
          z-index: 1055 !important;
        }
      `}</style>
    </>
  );
};

export default ConfirmModal;
